module.exports = __webpack_public_path__ + "img/power-swiper-item (10).3d005e8f.png";